class ProductDescriptionPanel extends HTMLElement {
  constructor() {
    super();
    this.tabs = this.querySelectorAll(".panel-tab");

    this.attachEventListners();
  }

  handleTabChange(e) {
    const index = e.target.getAttribute("data-controls-index");
    this.closest("description-panel").setAttribute("data-active-index", index);
  }

  attachEventListners() {
    this.tabs.forEach((tab) =>
      tab.addEventListener("click", this.handleTabChange)
    );
  }
}

customElements.define("description-panel", ProductDescriptionPanel);
